import type { ShouldSyncDraftArgs } from './types';

export const parseCommaSeparatedPatterns = (draft: string): string[] =>
  draft
    .split(',')
    .map(s => s.trim())
    .filter(Boolean);

export const arraysEqual = (a: string[], b: string[]): boolean =>
  a.length === b.length && a.every((value, index) => value === b[index]);

export const shouldSyncDraftFromStrings = ({
  bulkEditMode,
  justEnteredBulkEditMode,
  isFocused,
  textAreaDraft,
  strings,
}: ShouldSyncDraftArgs): boolean => {
  if (!bulkEditMode) return false;
  if (justEnteredBulkEditMode) return true;
  if (isFocused) return false;
  return !arraysEqual(parseCommaSeparatedPatterns(textAreaDraft), strings);
};
